<template>
  <div class="edit_main">
    <Form class="fx_1" ref="addModel" :model="addModel" :rules="ruleValidate" :label-width="100" inline>
      <FormItem label="科室名称" prop="departmentName">
        <Input class="w-250" v-model="addModel.departmentName"></Input>
      </FormItem>
      <FormItem label="科室编号" prop="departmentCode">
        <Input class="w-250" v-model="addModel.departmentCode"></Input>
      </FormItem>
      <FormItem label="科室类型" prop="departmentType">
        <Select class="w-250" v-model="addModel.departmentType">
          <Option
            v-for="(item, index) in departmentTypeSelect"
            :value="item.dictionaryID"
            :key="index"
          >{{ item.dictionaryValue }}</Option>
        </Select>
      </FormItem>

      <FormItem label="所属机构" prop="organName">
        <Button type="primary" @click="treeModel=true">选择机构</Button>
        <span class="ml-5">{{addModel.organName}}</span>
      </FormItem>
    </Form>
    <div class="edit_btn_group">
      <Button @click="returnBack" class="mr-5">取 消</Button>
      <Button type="success" @click="handleSubmit('addModel')">确 定</Button>
    </div>

    <Modal v-model="treeModel" title="选择机构">
      <organTree @selectTreeData="selectTreeData"></organTree>
    </Modal>
  </div>
</template>
<script>
import organTree from "../organ/organTree.vue";

export default {
  components: { organTree },
  data: function () {
    return {
      treeModel: false,
      organParentName: "",
      addModel: {
        departmentID: "",
        departmentName: "",
        departmentCode: "",
        departmentType: null,
        organID: "",
        organName: "",
      },
      departmentTypeSelect: [],
      ruleValidate: {
        departmentName: [
          {
            required: true,
            message: "科室名称不能为空",
          },
        ],
        departmentCode: [
          {
            required: true,
            message: "科室编号不能为空",
          },
        ],
        departmentType: [
          {
            required: true,
            message: "科室类型不能为空",
          },
        ],
      },
    };
  },

  created: function () {
    this.$common.getDictionary("科室类型").then((data) => {
      this.departmentTypeSelect = data;
    });
  },

  methods: {
    returnBack: function () {
      this.$router.push("department");
    },

    handleSubmit: function (from) {
      this.$refs[from].validate((valid) => {
        if (valid) {
          if (!this.addModel.organID) {
            this.$Message.warning("请选择所属机构");
            return;
          }
          this.$api.post("department/create", this.addModel).then((rsp) => {
            if (rsp != false) {
              this.$Message.success("添加成功");
              this.$refs["addModel"].resetFields();
              this.returnBack();
            }
          });
        }
      });
    },
    selectTreeData: function (data) {
      this.addModel.organID = data[0].organID;
      this.addModel.organName = data[0].title;
    },
  },
};
</script>
<style scoped>
</style>